import { useEffect, useSyncExternalStore } from 'react';
import { ModalDialog } from './ModalDialog';
import { confirmationStore } from '../lib/confirmation';

export function ConfirmationHost(): import("react").JSX.Element | null {
  useEffect(() => confirmationStore.cancelAll, []);
  const request = useSyncExternalStore(confirmationStore.subscribe, confirmationStore.snapshot);
  if (!request) return null;
  const finish = (value: string | boolean | null): void => {
    confirmationStore.finish(request, value);
  };
  return <ModalDialog key={request.message} isOpen title={request.kind === 'prompt' ? 'Provide details' : 'Confirm action'}
    type={request.kind} message={request.message}
    promptFields={request.kind === 'prompt' ? [{ key: 'value', label: 'Details', type: 'textarea' }] : []}
    onCancel={(): void => finish(request.kind === 'prompt' ? null : false)}
    onConfirm={values => finish(request.kind === 'prompt' ? values?.value ?? '' : true)} />;
}
